import React from 'react';
import PropTypes from 'prop-types';

const Lock02Icon = ({color = 'currentColor', ...props}) => (
  <svg
    width="14"
    height="18"
    viewBox="0 0 14 18" fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.5 6.33333V5.57143C2.5 3.039 4.50714 1 7 1C9.49286 1 11.5 3.039 11.5 5.57143V6.33333M2.5 6.33333C1.675 6.33333 1 7.01905 1 7.85714V15.4762C1 16.3143 1.675 17 2.5 17H11.5C12.325 17 13 16.3143 13 15.4762V7.85714C13 7.01905 12.325 6.33333 11.5 6.33333M2.5 6.33333H11.5M7 12.5V10.5"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
    />
  </svg>

);

Lock02Icon.propTypes = {
  color: PropTypes.string,
};

export default Lock02Icon;

